export default __webpack_public_path__ + "img/iosmovil.4bc89fa1.svg";